import { GridRowSelectionModel, GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import PageLayout from "../../../../../components/PageLayout";
import { useAppointmentReportList } from "../../../../../queries/appointment/use-appointment-report-list";
import { useAppointmentDashboardStats } from "../../../../../queries/appointment/use-appointment-dashboard-stats";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  getXtenantId,
} from "../../../../../utils/utils";
import AppointmentReportKPICards from "./AppointmentReportKPICards";
import AppointmentReportTable from "./AppointmentReportTable";
import { AppointmentReportFilterData } from "./appointment-report-constants";
import { extractFilterValue, resolveDateRange } from "../report-constants";

interface AppointmentSchedulingReportProps {
  filters: AppointmentReportFilterData;
  onFilterChange: (filters: AppointmentReportFilterData) => void;
  rowSelectionModel: GridRowSelectionModel;
  onRowSelectionModelChange: (model: GridRowSelectionModel) => void;
}

const AppointmentSchedulingReport = ({
  filters,
  rowSelectionModel,
  onRowSelectionModelChange,
}: AppointmentSchedulingReportProps) => {
  const providerGroupId = getXtenantId();

  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);

  const resolved = resolveDateRange(
    filters.date_range,
    filters.startDate,
    filters.endDate
  );
  const startDate = resolved.startDate;
  const endDate = resolved.endDate;
  const providerVal = extractFilterValue(filters.provider_Name);
  const locationVal = extractFilterValue(filters.location);
  const statusVal = extractFilterValue(filters.appointment_Status);
  const modeVal = extractFilterValue(filters.appointment_Mode);
  const sourceVal = extractFilterValue(filters.scheduled_Source);

  const providerUuid = providerVal ? [providerVal] : undefined;
  const locationUuid = locationVal ? [locationVal] : undefined;
  const statuses =
    statusVal && statusVal !== "ALL_STATUSES" ? [statusVal] : undefined;
  const modes = modeVal && modeVal !== "ALL_MODE" ? [modeVal] : undefined;
  const scheduledSources =
    sourceVal && sourceVal !== "ALL_SOURCE" ? [sourceVal] : undefined;
  // const searchKey = filters.diagnosis || undefined;

  const {
    data: listData,
    isLoading: listLoading,
    isRefetching: listRefetching,
  } = useAppointmentReportList({
    pagination,
    gridSorting,
    startDate,
    endDate,
    statuses,
    modes,
    providerUuid,
    locationUuid,
    scheduledSources,
    providerGroupId,
    // searchKey,
  });

  const { data: statsData, isLoading: statsLoading } =
    useAppointmentDashboardStats({
      startDate,
      endDate,
      providerUuid,
      locationUuid,
      providerGroupId,
      statuses,
      modes,
      scheduledSources,
    });

  return (
    <PageLayout
      header={
        <AppointmentReportKPICards
          data={statsData?.data}
          isLoading={statsLoading}
        />
      }
    >
      <AppointmentReportTable
        rows={listData?.data?.content ?? []}
        rowCount={listData?.data?.page?.totalElements ?? 0}
        loading={listLoading || listRefetching}
        pagination={pagination}
        onPaginationChange={setPagination}
        gridSorting={gridSorting}
        onSortChange={setGridSorting}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={onRowSelectionModelChange}
      />
    </PageLayout>
  );
};

export default AppointmentSchedulingReport;
